import { library } from "@fortawesome/fontawesome-svg-core";
import {
  fab,
  faWhatsapp,
  faFacebook,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import {
  fas,
  faFlask,
  faMapMarker,
  faBackward,
  faSignInAlt,
  faShoppingCart,
  faTrashAlt,
  faListAlt,
  faEye,
  faChevronRight,
  faChevronLeft,
  faUser,
  faClock,
  faStore,
  faBicycle,
  faIdCard,
  faAt,
  faPhone
} from "@fortawesome/free-solid-svg-icons";

library.add(
  fas,
  fab,
  faFlask,
  faWhatsapp,
  faFacebook,
  faInstagram,
  faMapMarker,
  faBackward,
  faSignInAlt,
  faShoppingCart,
  faTrashAlt,
  faListAlt,
  faEye,
  faChevronRight,
  faChevronLeft,
  faUser,
  faClock,
  faStore,
  faBicycle,
  faIdCard,
  faAt,
  faPhone
);
